export default __webpack_public_path__ + "static/media/30.80d5d91a.png";